'use client';

import { useTracker } from '@lichtblick/tracker';
import { usePathname } from 'next/navigation';
import { type FC, useEffect } from 'react';

import { initReactComponents } from './reactComponentsInitializer';
import { initTracking } from './reactTrackingInitializer';

export const LegacyReactComponentInitializer: FC = () => {
  const _pathname = usePathname();
  const { trackCustomEvent } = useTracker();

  useEffect(() => {
    initReactComponents();

    return initTracking(trackCustomEvent);
  }, [trackCustomEvent]);

  return null;
};
